import { forwardRef } from 'react'

const variantClasses = {
  primary:
    'bg-brand-orange text-white hover:bg-brand-gold focus-visible:ring-brand-orange',
  secondary:
    'border-2 border-brand-orange text-brand-orange hover:bg-brand-orange/10 focus-visible:ring-brand-orange',
  ghost:
    'text-brand-orange hover:bg-brand-orange/10 focus-visible:ring-brand-orange',
  success:
    'bg-green-600 text-white hover:bg-green-700 focus-visible:ring-green-600',
  gold: 'bg-brand-gold text-brand-blue hover:bg-brand-orange focus-visible:ring-brand-gold',
  dark: 'bg-brand-blue text-brand-gold hover:bg-brand-blue/90 focus-visible:ring-brand-blue',
}

const sizeClasses = {
  sm: 'px-4 py-1.5 text-sm',
  md: 'px-6 py-2 text-base',
  lg: 'px-8 py-3 text-lg',
}

const UiButton = forwardRef(function UiButton(
  {
    children,
    variant = 'primary',
    size = 'md',
    fullWidth = false,
    disabled = false,
    className = '',
    icon: Icon,
    iconPosition = 'left',
    ...props
  },
  ref
) {
  const baseClasses =
    'inline-flex items-center justify-center gap-2 rounded-full font-climate font-bold transition focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed'

  return (
    <button
      ref={ref}
      disabled={disabled}
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${
        fullWidth ? 'w-full' : ''
      } ${className}`}
      {...props}
    >
      {Icon && iconPosition === 'left' && <Icon size={20} aria-hidden="true" />}
      {children}
      {Icon && iconPosition === 'right' && <Icon size={20} aria-hidden="true" />}
    </button>
  )
})

export default UiButton
